import { Link } from "wouter";
import BrandLockup from "@/components/BrandLockup";

export default function AccountDeleted() {
  return (
    <div className="paper-shell inner-shell">
      <header className="site-header"><BrandLockup /></header>
      <main className="account-deleted-layout">
        <section className="form-card" role="status" aria-live="polite">
          <p className="eyebrow"><span className="eyebrow-rule" /> Home, Twice</p>
          <h1>Your account<br />has been deleted<span className="title-period">.</span></h1>
          <p className="form-description">
            Your saved recordings and active share links have been removed. You’ve been signed out.
          </p>
          <Link href="/" className="primary-action full-width">
            Return home <span aria-hidden="true">→</span>
          </Link>
        </section>
      </main>
      <footer className="site-footer">
        <nav className="legal-footer-links" aria-label="Legal">
          <Link href="/privacy">Privacy Policy</Link>
          <Link href="/terms">Terms</Link>
        </nav>
        <span>Published by Kwaderno &amp; Co.</span>
      </footer>
    </div>
  );
}
